import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { UserService } from '@app/services/user.service'
import { Router } from '@angular/router';
import { path_module_employer, path_module_public } from '@app/models/routes.name';
import { profile_access_module } from '@app/config/role-name.enum';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModuleRoleGuard implements CanLoad {
  module: profile_access_module;
  subscription: Subscription;

  constructor(
    private userService: UserService,
    private router: Router
  ) {

    this.subscription = this.userService.roleBehavior.pipe().subscribe(value => {
      if (value !== null && this.module) {
        this.canLoad(null, null);
      }
    })

  }

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {

    await this.userService.loadPermissions();

    this.module = route?.data?.['module'] || this.module;

    if (this.module && this.userService.hasAccessToModule(this.module)) {
      return true;
    }


    this.unsuscribeRoleBehavior();

    if (!this.userService.loggedIn()) {
      this.router.navigate([path_module_employer.module, path_module_employer.login], { queryParams: { returnUrl: this.router.url } });
    }
    else {
      this.router.navigate([path_module_public.forbbiden]);
    }

    return false;
  }

  ngOnDestroy() {
    this.unsuscribeRoleBehavior();
  }

  unsuscribeRoleBehavior() {
    if (this, this.subscription) { this.subscription.unsubscribe(); }
  }
}
